<template>
    <vx-card class="w-11/12 shadow-lg">
        <action-bar class="action-bar">
            <template v-slot:left>
                <h2>Players</h2>
            </template>
            <template v-slot:right>
                <vx-action-icon
                    icon="PlusSquareIcon"
                    tooltip="Add Content"
                    @click="$router.push('/players/new')"
                >
                </vx-action-icon>
            </template>
        </action-bar>

        <vx-server-side-table
            striped
            class="px-4"
            ref="servertable"
            search
            v-model="selected"
            :fetchData="$api.playlist.fetchPlaylists"
            :columns="columns"
            :filters.sync="customFilters"
        >
            <template slot="header-filter">
                <vx-select
                    label="Filter by Genre"
                    name="Genre"
                    placeholder="Filter by Genre"
                    style="width: 300px"
                    class="ml-5 mt-5"
                    v-model="searchGenreId"
                    :options="genres"
                    valueKey="id"
                    textKey="name"
                    removeValidationPadding
                >
                </vx-select>
            </template>
            <template v-slot:State="{ row }">
                <vx-tooltip :title="stateToolTip(row.publishState)">
                    {{ stateDescription(row.publishState) }}
                </vx-tooltip>
            </template>

            <template v-slot:Status="{ row }">
                <vx-tooltip :title="statusToolTip(row.publishingStatus)">
                    {{ statusDescription(row.publishingStatus) }}
                </vx-tooltip>
            </template>

            <template v-slot:Action="{ row }">
                <div class="flex">
                    <vx-action-icon
                        icon="CheckCircleIcon"
                        hover-color="success"
                        tooltip="Ready to Publish"
                        :disabled="row.publishingStatus != 0"
                        @click.stop.prevent="setReadyStatus(row)"
                    />
                    <vx-action-icon
                        class="ml-4"
                        icon="StopCircleIcon"
                        hover-color="warning"
                        tooltip="Put On Hold"
                        :disabled="row.publishingStatus == 2 || row.publishingState == 2"
                        @click.stop.prevent="setOnHoldStatus(row)"
                    />
                </div>
            </template>
        </vx-server-side-table>
    </vx-card>
</template>

<script>
import ActionBar from '@/components/custom/ActionBar'
import { mapParams } from '@/plugins/mappers'
import { mapGetters } from 'vuex'
import publishMixins from '../mixins/publishMixins'

export default {
    name: 'players-table',
    components: {
        ActionBar
    },
    mixins: [publishMixins],
    data() {
        return {
            coupons: [],
            genres: [],
            selectedX: null,
            searchGenreId: -1,
            search_text: ''
        }
    },
    computed: {
        ...mapParams('product_id'),
        ...mapGetters({
            edition: 'auth/edition'
        }),
        customFilters: {
            get() {
                return {
                    genreId:
                        this.searchGenreId && this.searchGenreId != -1 ? this.searchGenreId : null,
                    search: this.search_text
                }
            },
            set(val) {
                this.search_text = val.search
                this.searchGenreId = val.genreId ? val.genreId : -1
            }
        },
        columns() {
            return [
                { title: 'Name', value: 'name', sort: 'name' },
                { title: 'Description', value: 'description' },
                { title: 'Genre', value: 'genre.name', sort: 'genre' },
                { title: 'Sort Order', value: 'sortOrder', sort: 'sortOrder' },
                { title: 'Locked', value: (v) => (v.isLocked ? 'Yes' : 'No'), sort: 'isLocked' },
                {
                    title: 'Home Screen',
                    value: (v) => (v.displayOnHomeScreen ? 'Yes' : 'No'),
                    sort: 'displayOnHomeScreen'
                },
                {
                    title: 'Experience Level',
                    value: (v) => this.expLevel(v.experienceRequired),
                    sort: 'experienceRequired'
                },
                {
                    title: 'Content Type',
                    value: (v) => (v.contentType == 1 ? 'Single' : 'Playlist'),
                    sort: 'contentType'
                },
                {
                    title: 'Publishing Date',
                    value: (v) => new Date(v.dateToPublishLive).toLocaleDateString('en-AU'),
                    sort: 'dateToPublishLive'
                },
                {
                    title: 'State',
                    style: 'white-space: nowrap;',
                    sort: 'state'
                },
                {
                    title: 'Status',
                    value: (v) => this.statusDescription(v.publishingStatus),
                    style: 'white-space: nowrap;',
                    sort: 'publishingStatus'
                },
                { title: 'Action', value: '', style: 'width: 50px' }
            ]
        },
        selected: {
            get() {
                return this.selectedX
            },
            set(val) {
                this.selectedX = val
                this.$router.push(`/players/${val.id}`)
            }
        }
    },
    watch: {
        edition: {
            handler: function (newVal, oldVal) {
                if (!newVal.isPublishing && oldVal.isPublishing) {
                    this.$refs.servertable.reset()
                }
            }
        }
    },
    methods: {
        expLevel(exp) {
            if (exp > 0 && exp <= 33) {
                return 'Beginner'
            } else if (exp > 33 && exp <= 66) {
                return 'Intermediate'
            } else {
                return 'Advanced'
            }
        },

        setReadyStatus(row) {
            try {
                var response = this.$api.playlist.setReady(row)
                row.publishingStatus = 1
                this.notifySuccess('Updated successfully', 'Status set to Ready successfully', 5000)
            } catch (err) {
                console.error(err)
                this.notifyError('Error', `Error message: ${err}`, 5000)
            }
        },
        setOnHoldStatus(row) {
            try {
                var response = this.$api.playlist.setOnHold(row)
                row.publishingStatus = 2
                this.notifySuccess(
                    'Updated successfully',
                    'Status set to On Hold successfully',
                    5000
                )
            } catch (err) {
                console.error(err)
                this.notifyError('Error', `Error message: ${err}`, 5000)
            }
        },
        refreshTable() {
            this.$refs.servertable.reset()
        }
    },
    async mounted() {
        var genreResponse = await this.$api.genre.fetchGenres({ pageSize: 500 })
        this.genres = [{ id: -1, name: 'All' }, ...genreResponse.data]
        this.globalOn('updated-player', this.refreshTable)
    }
}
</script>

<style scoped>
h2 {
    color: #6a6e6e;
}
::v-deep .vs-card--content {
    min-height: 40vh;
}
</style>
